import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import {
  getDifferencesColumnNames,
  fetchDifferences,
  transformDifferences
} from 'SensitiveDataLandscape/LandscapeUtils';

const TimeSeriesHint = (props) => {
  const [fetchingData, setFetchingData] = useState(true);
  const [summary, setSummary] = useState({ newTables: 0, newColumns: 0, reducedColumns: 0 });

  const tooltipData = props.tooltipData || {};
  const prevSearchids = tooltipData.prevSearchids || [];
  const searchids = tooltipData.searchids;

  const fetchDataHandler = async () => {
    setFetchingData(true);
    try {
      if (prevSearchids.length && searchids.length) {
        const response = await fetchDifferences(prevSearchids, searchids);
        const transformedDifferences = transformDifferences(response);
        const differences = await getDifferencesColumnNames(transformedDifferences);
        setSummary(differences.summary || { newTables: 0, newColumns: 0, reducedColumns: 0 });
      }
    } catch(e) {
      console.log(e);
    }
    setFetchingData(false);
  }

  useEffect(() => {
    fetchDataHandler();
  }, []);

  const hasChanges = summary.newTables > 0 || summary.newColumns > 0 || summary.reducedColumns > 0;

  return (
      <div
        className='timeseries-tooltip'
      >
        { fetchingData ? (
          <Spinner animation='border' variant='primary' />
        ) : (
          <div>
            <p>{tooltipData.y} total sensitive fields</p>

            { hasChanges ? (
              <>
                { summary.newTables > 0 && (
                  <p style={{ color: '#D97706', margin: 0 }}>
                    + {summary.newTables} new {props.tableLabel || tooltipData.tableLabel || 'table'}{summary.newTables === 1 ? '' : 's'} with sensitive data
                  </p>
                )}
                { summary.newColumns > 0 && (
                  <p style={{ color: '#D97706', margin: 0 }}>
                    + {summary.newColumns} new sensitive column{summary.newColumns === 1 ? '' : 's'}
                  </p>
                )}
                { summary.reducedColumns > 0 && (
                  <p style={{ color: '#16A34A', margin: 0 }}>
                    - {summary.reducedColumns} column{summary.reducedColumns === 1 ? '' : 's'} no longer sensitive
                  </p>
                )}
              </>
            ) : (
              <p style={{ margin: 0, opacity: 0.7 }}>No change from previous scan</p>
            )}
          </div>
        )}
      </div>
  )
}

export default TimeSeriesHint;